import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const PageHero = ({ eyebrow, title, description, image, breadcrumb }) => {
  return (
    <section className="relative overflow-hidden bg-brand text-white" data-testid="page-hero">
      <div className="grain absolute inset-0" />
      {image && (
        <>
          <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" />
          <div className="absolute inset-0 bg-gradient-to-r from-brand via-brand/90 to-brand/60" />
        </>
      )}
      <div className="pointer-events-none absolute -top-24 -right-16 h-96 w-96 rounded-full bg-brand-accent/20 blur-3xl" />
      <div className="container-x relative py-20 lg:py-28">
        {breadcrumb && (
          <nav className="mb-6 flex items-center gap-2 text-sm text-white/60" data-testid="breadcrumb">
            <Link to="/" className="hover:text-white transition-colors">Home</Link>
            <ChevronRight className="h-4 w-4" />
            <span className="text-white">{breadcrumb}</span>
          </nav>
        )}
        {eyebrow && (
          <motion.span
            initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
            className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.25em] text-brand-sky mb-5"
          >
            <span className="h-px w-8 bg-brand-sky" />{eyebrow}
          </motion.span>
        )}
        <motion.h1
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="font-heading font-extrabold tracking-tighter leading-[0.95] text-5xl sm:text-6xl md:text-7xl max-w-4xl"
        >
          {title}
        </motion.h1>
        {description && (
          <motion.p
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.15 }}
            className="mt-6 max-w-2xl text-lg text-white/75 leading-relaxed"
          >
            {description}
          </motion.p>
        )}
      </div>
    </section>
  );
};
